import { Component, input, output } from '@angular/core';

import {
    ButtonIconPos,
    ButtonSeverity,
    ButtonSize,
    ButtonType,
} from '../interfaces/button.interface';

// The one button every page uses, so they all look and behave alike.
@Component({
    standalone: false,
    selector: 'app-button',
    templateUrl: './button.component.html',
})
export class ButtonComponent {
    readonly label = input<string>('');
    readonly icon = input<string | undefined>(undefined);
    readonly iconPos = input<ButtonIconPos>('left');
    readonly type = input<ButtonType>('button');
    readonly severity = input<ButtonSeverity>('primary');
    readonly size = input<ButtonSize>(undefined);
    readonly outlined = input(false);
    readonly text = input(false);
    readonly fluid = input(false);
    readonly loading = input(false);
    readonly disabled = input(false);
    // Shown on hover while the button is off, such as what permission is missing.
    readonly disabledReason = input('');
    readonly ariaLabel = input<string | undefined>(undefined);
    readonly testId = input<string | undefined>(undefined);

    readonly clicked = output<MouseEvent>();
}
